import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { DataConnections } from '~src/datasource/dataConnection/resources/DataConnections';

import { ExtractEncryptionMode } from '../../../../commonInfra/utils/sites/SitePropertyTypes';
import { ExtractEncryptionState, IDataSourceInfo } from '../../../../datasource/models/IDataSourceInfo';
import { DataSources } from '../../../../datasource/resources/Datasources';
import { SpaceHeaderStyles } from '../../../components/header/SpaceHeaderStyles';
import { SpacesSiteUrls } from '../../spaceComponents/SpacesSiteUrls';
import { StatusToolTip } from '../../tooltip/StatusToolTip';
import { TooltipAnchor } from '../../tooltip/TooltipAnchor';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { DateTimeText } from './DateTimeCells';

// The linter is flagging a potentially interesting problem (this code existed before we enabled
// this lint rule). Disabling the lint rule for now, tracking the problem in TFS 1257623.

export function LastRefreshedCell(siteUrl: SpacesSiteUrls, isExtractEncryptionEnabled: boolean, siteEaRMode: ExtractEncryptionMode, isWorkbookPlace?: boolean): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function LastRefreshedCell(props: BodyCell.Props) {
        const datasource = props.row.data as IDataSourceInfo;
        let psExtracts  = datasource.publishedDatasourceDetails? datasource.publishedDatasourceDetails.hasExtracts : false;
        let esExtracts  = datasource.hasExtracts;
        let isExtract = esExtracts || psExtracts;
        const spaceUrls = siteUrl;

        const labelStyle: React.CSSProperties = {
          marginRight: 18,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        };

        const [contentText, setContentText] = React.useState('');
        const [federatedConnections, setFederatedConnections] = React.useState(0);

        React.useEffect(() => {
          let federatedFile = 0;
          let federatedDatabase =0;
          let multipleConnections: string;
          const dateTimeOptions = {...props, propertyName: 'dataFreshness'};
          const lastRefreshedCell = true;
          const total_Connections = datasource.dataConnectionsCount;
          const dateTime =  DateTimeText(dateTimeOptions);
          const delimiter = (isExtract && dateTime)? String.fromCharCode(8212): String.fromCharCode(8195);
          const extractStatus = DataSources.DatasourceStatus(isExtractEncryptionEnabled, datasource.connectionType,datasource.isFileBased,isExtract,
            datasource.extractEncryptionState, datasource.extractCreationPending, siteEaRMode,lastRefreshedCell);

          if(total_Connections === 1) {
            setFederatedConnections(0);
            setContentText(`${extractStatus}${delimiter}${dateTime}`);
            return;
          }

           DataConnections.getConnections(datasource).then((conn) => {
                setFederatedConnections(conn.length-1);
                if (isExtract) {
                  multipleConnections = extractStatus;
                }
                else {
                  for(let i=0; i< conn.length;i++) {
                    if(conn[i].connectionDetails.type === 'file') {
                          federatedFile = federatedFile+1;}
                    else {
                      federatedDatabase = federatedDatabase+1;}
                  }
                  if(federatedFile >0 && federatedDatabase >0){
                    multipleConnections = Messages.federatedFileBased({COUNT: federatedFile}) + ','+ Messages.liveConnection();
                  }
                  else if (federatedDatabase === 0){
                    multipleConnections = Messages.federatedFileBased({COUNT: federatedFile});
                  }
                  else{
                    multipleConnections = Messages.liveConnection();
                  }
                }

            setContentText(`${multipleConnections}${delimiter}${dateTime}`);
          });
        }, [props, datasource, isExtract]);
        return (
            <div style={labelStyle}>
              {
                datasource.extractEncryptionState === ExtractEncryptionState.pendingDecryption ||
                    datasource.extractEncryptionState === ExtractEncryptionState.pendingEncryption ||
                    (!isExtract && datasource.extractCreationPending)
                    ?
                    <span key={1} className={SpaceHeaderStyles.ExtractStatusSpinner}>
                  <ActivitySpinnerWidget testId="extract-status" spinnerSize={ActivitySpinnerSize.Small}/>
            </span>
                    : null
              }
              { datasource.connectionDetails &&
                <TooltipAnchor tooltipContent={() => <StatusToolTip content = {props.row.data as IDataSourceInfo}
                urls = {spaceUrls} federatedCount={federatedConnections} isWorkbookPlace ={isWorkbookPlace}/>}
                  disableAutoFocus={true}
                  title={Messages.datasourceDetails()}
                  disableTooltip={false}
                >
                  {contentText}
                </TooltipAnchor>
              }
              {
                !datasource.connectionDetails && <>{contentText}</>
              }
            </div>
        );
      }
  );
}
